import { useQuery } from '@tanstack/react-query';

const useGetRequest = ({ fetch, key, enabled = true, noCache = false, retry = false }) => {
  const { data, isLoading, refetch, error } = useQuery({
    queryKey: key,
    queryFn: fetch,
    enabled,
    refetchOnWindowFocus: false,
    ...(noCache && { gcTime: 0 }),
    retry,
  });

  return {
    data,
    loading: isLoading,
    refetch,
    error,
  };
};

export default useGetRequest;
